import { memo } from "react";

import { formatDateShort } from "../../../utils";
import { InspectionfieldStateEnum } from "./__generated__/InspectionDetailsContainer.graphql";
import { StateColors, StateTitles } from "../../InspectionList/StateHelpers";
import Button from "../../../components/Buttons/Button";
import IconButton, { getIcon } from "../../../components/Buttons/IconButton";

import { InspectionFieldTable, Spacer } from "../Styles";

type Nullable<T> = T | null;
export const InspectionDetails = memo(function Comp(props: {
  state?: Nullable<InspectionfieldStateEnum>;
  year?: number;
  memberName?: Nullable<string>;
  memberPhone?: Nullable<string>;
  memberEmail?: Nullable<string>;
  projectName?: Nullable<string>;
  periodStart?: Nullable<string>;
  periodEnd?: Nullable<string>;
  plannedDate?: Nullable<string>;
  approvedDate?: Nullable<string>;
  rejectedDate?: Nullable<string>;
  assignedDate?: Nullable<string>;
  reason?: Nullable<string>;
  lastModified?: Nullable<string>;
  retryDate?: Nullable<string>;
  address?: Nullable<{
    street: Nullable<string>;
    houseNumber: Nullable<number>;
    zipcode: Nullable<string>;
    city: Nullable<string>;
  }>;
  onPlan?: Function;
  projectPdfUrl?: Nullable<string>;
  notes?: Nullable<string>;
}) {
  return (
    <InspectionFieldTable>
      <tbody>
        <tr>
          <th>Status</th>
          <td>
            {props.state &&
              getIcon("dot", "small", false, StateColors[props.state])}
            <Spacer></Spacer>
            {props.state && StateTitles[props.state]}
          </td>
        </tr>
        <tr>
          <th>Beheerpakket</th>
          <td>
            {props.projectPdfUrl ? (
              <a target="_blank" href={props.projectPdfUrl} rel="noreferrer">
                {props.projectName}
              </a>
            ) : (
              props.projectName
            )}
          </td>
        </tr>
        <tr>
          <th>Beheerjaar</th>
          <td>{props.year}</td>
        </tr>
        {props.periodStart && props.periodEnd && (
          <tr>
            <th>
              {props.periodStart && props.periodEnd
                ? "Periode"
                : props.periodStart
                ? "Start periode"
                : "Eind periode"}
            </th>
            <td>
              {props.periodStart ? formatDateShort(props.periodStart) : null}
              {props.periodStart && props.periodEnd ? " t/m " : null}
              {props.periodEnd ? formatDateShort(props.periodEnd) : null}
            </td>
          </tr>
        )}
        {props.assignedDate && (
          <tr>
            <th>Datum toegewezen</th>
            <td>{formatDateShort(props.assignedDate)}</td>
          </tr>
        )}
        {props.lastModified ? (
          <tr>
            <th>Laatst bewerkt op</th>
            <td>{formatDateShort(props.lastModified)}</td>
          </tr>
        ) : null}
        {props.state && (
          <tr>
            <th>
              {["ASSIGNED", "PLANNED"].includes(props.state) &&
                "Datum ingepland"}
              {["APPROVED", "REJECTED", "RETRY"].includes(props.state) &&
                "Datum uitgevoerd"}
            </th>
            <td>
              {props.state === "ASSIGNED" ? (
                <>
                  <Button
                    label={"Inplannen"}
                    onClick={() => props.onPlan && props.onPlan()}
                  />
                </>
              ) : props.state === "PLANNED" ? (
                <>
                  {props.state &&
                    getIcon(
                      "calendar",
                      "small",
                      false,
                      StateColors[props.state]
                    )}
                  <Spacer></Spacer>
                  {(props.plannedDate && formatDateShort(props.plannedDate)) ||
                    "Onbekend"}
                  <Spacer></Spacer>
                  <IconButton
                    icon="pencil"
                    inline
                    tooltip="Wijzig ingeplande datum"
                    onClick={() => props.onPlan && props.onPlan()}
                  />
                </>
              ) : props.approvedDate ||
                props.rejectedDate ||
                props.retryDate ? (
                <>
                  {formatDateShort(
                    props.approvedDate ||
                      props.rejectedDate ||
                      props.retryDate ||
                      ""
                  )}
                </>
              ) : null}
            </td>
          </tr>
        )}
        {props.reason !== null && (
          <tr>
            <th>Reden</th>
            <td>{inspectionReason(props.reason)}</td>
          </tr>
        )}
        <tr>
          <th>Deelnemer</th>
          <td>{props.memberName}</td>
        </tr>
        <tr>
          <th>Adres</th>
          <td>
            {props.address ? (
              <div className="member-address">
                {props.address.street} {props.address.houseNumber}
                <br />
                {props.address.zipcode} {props.address.city}
              </div>
            ) : null}
          </td>
        </tr>
        <tr>
          <th>Telefoonnummer</th>
          <td>{props.memberPhone}</td>
        </tr>
        <tr>
          <th>E-mail</th>
          <td>{props.memberEmail}</td>
        </tr>
        {props.notes && props.notes.trim() !== "" && (
          <tr>
            <th>Notitie</th>
            <td>
              <i>{props.notes}</i>
            </td>
          </tr>
        )}
      </tbody>
    </InspectionFieldTable>
  );
});

function inspectionReason(code: string | undefined) {
  switch (code) {
    case "A_0":
      return "Algemeen";
    case "A_1":
      return "Melding";
    case "A_2":
      return "Niet akkoord";
    case "A_3":
      return "Aanvraag schouwer";
    default:
      return "-";
  }
}
